import { render } from "./ContentFileListModalOrganic.vue?vue&type=template&id=5986dfd5"
import script from "./ContentFileListModalOrganic.vue?vue&type=script&lang=js"
export * from "./ContentFileListModalOrganic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__